import { jsx as _jsx } from "react/jsx-runtime";
import { ListBox } from '../../elements/ListBox';
import { Link } from '../../elements/Link';
import { useComponentConfig } from '../../providers/componentConfig';
import { Dropdown } from '../../elements/Dropdown';
export const DropdownLinks = ({ children, options: optionsParam, renderOption: renderOptionParam, openNewTab, role = 'navigation', }) => {
    const { navigate } = useComponentConfig().link;
    const renderOption = renderOptionParam
        ? renderOptionParam
        : (params) => (_jsx(Link, Object.assign({ to: params.option.value, target: openNewTab ? '_blank' : undefined, onClick: (e) => {
                e.preventDefault();
            } }, { children: params.option.label })));
    return (_jsx(Dropdown, { shouldRenderDropdownContainer: false, renderAnchor: children, renderDropdown: ({ ref, styles, id, setIsOpen }) => {
            const options = optionsParam.map((option) => (Object.assign(Object.assign({}, option), { onClick: () => {
                    if (option.onClick) {
                        option.onClick();
                    }
                    else if (openNewTab) {
                        window.open(option.value, '_blank');
                    }
                    else if (option.value) {
                        navigate(option.value);
                    }
                    setIsOpen(false);
                } })));
            return (_jsx(ListBox, { role: role, id: id, options: options, ref: ref, renderOption: renderOption, style: styles }));
        } }));
};
